import { render, staticRenderFns } from "./index.vue?vue&type=template&id=121a6f21&scoped=true&"
import script from "./composition.js?vue&type=script&lang=js&"
export * from "./composition.js?vue&type=script&lang=js&"
import style0 from "../styles.scss?vue&type=style&index=0&id=121a6f21&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121a6f21",
  null
  
)

export default component.exports